import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ChatsSidebarPayload, LEFT_MENU, MenuItem, RIGHT_MENU } from './chat-sidebar.interface';
import { CHAT_TYPES } from '../../../enum/constants';
import { ChatService } from '../../../services/chat.service';
import { BaseService } from '../../../services/base.service';
import { Subject, takeUntil } from 'rxjs';
import { WebSocketService } from '../../../services/gateway.service';

@Component({
  selector: 'app-chats-sidebar',
  templateUrl: './chat-sidebar.component.html',
  styleUrls: ['./chat-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatSidebarComponent implements OnInit, OnDestroy {
  private readonly destroy$: Subject<void> = new Subject<void>();
  protected readonly menuItems: MenuItem[] = this.chatService.menuItems;

  @Input() payload?: ChatsSidebarPayload;
  @Output() close = new EventEmitter<any>();

  constructor(
    private readonly webSocketService: WebSocketService,
    protected readonly chatService: ChatService,
    protected readonly baseService: BaseService,
  ) {}

  ngOnInit(): void {
    this.initSelectedTab();
    this.chatService.initAvailableTypes();
    this.initSockets();

    if (this.payload?.chatId) {
      this.chatService.selectChat(this.payload.chatId);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initSelectedTab(): void {
    const selectedTabKey = localStorage.getItem('selectedTabKey');
    if (selectedTabKey) {
      this.chatService.selectedTab = this.menuItems.find((menu) => menu.key === selectedTabKey) as MenuItem;
    }
    if (!this.chatService.selectedTab) {
      this.chatService.selectedTab = this.menuItems[0];
    }
  }

  private initSockets(): void {
    this.webSocketService
      .delayedMessages()
      .pipe(takeUntil(this.destroy$))
      .subscribe((chatId) => {
        this.chatService.refreshDelayedMessages(chatId);
      });
  }

  protected onClose() {
    this.chatService.closeLeftMenu();
    this.chatService.closeRightMenu();
    this.close.emit();
  }

  protected onChangeTab(tabKey: string) {
    this.chatService.selectedTab = this.menuItems.find((menu) => menu.key === tabKey) || this.menuItems[0];
    localStorage.setItem('selectedTabKey', this.chatService.selectedTab.key);
  }

  protected readonly CHAT_TYPES = CHAT_TYPES;
  protected readonly LEFT_MENU = LEFT_MENU;
  protected readonly RIGHT_MENU = RIGHT_MENU;
}
